import React, { useEffect, useState, useContext } from 'react';
import { db } from '../../../firebase';
import { Link } from 'react-router-dom';
import { collection, getDocs, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus, faTrash, faSave } from '@fortawesome/free-solid-svg-icons';
import AddReservationModal from './AddReservationModal';
import EditReservationModal from './EditReservationModal';
import ReactPaginate from 'react-paginate';
import { UserContext } from '../../../contexts/UserContext';
import { Modal, Button } from 'react-bootstrap';

const Reservations = () => {
    const [reservations, setReservations] = useState([]);
    const [editedStatuses, setEditedStatuses] = useState({});
    const [showEditModal, setShowEditModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [selectedReservation, setSelectedReservation] = useState(null);
    const [nameFilter, setNameFilter] = useState('');
    const { user } = useContext(UserContext);

    // For confirmation modal
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [reservationToDelete, setReservationToDelete] = useState(null);

    // Pagination states
    const [currentPage, setCurrentPage] = useState(0);
    const reservationsPerPage = 10;

    useEffect(() => {
        const fetchReservations = async () => {
            try {
                const reservationsCollection = collection(db, 'reservation');
                const reservationsSnapshot = await getDocs(reservationsCollection);
                let reservationsList = reservationsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                // Apply name filter
                if (nameFilter) {
                    reservationsList = reservationsList.filter(reservation =>
                        reservation.date.toLowerCase().includes(nameFilter.toLowerCase())
                    );
                }

                setReservations(reservationsList);
            } catch (error) {
                console.error("Error fetching reservations: ", error);
            }
        };

        fetchReservations();
    }, [nameFilter]);

    const indexOfLastReservation = (currentPage + 1) * reservationsPerPage;
    const indexOfFirstReservation = indexOfLastReservation - reservationsPerPage;
    const currentReservations = reservations.slice(indexOfFirstReservation, indexOfLastReservation);
    const pageCount = Math.ceil(reservations.length / reservationsPerPage);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const handleShowEdit = (reservation) => {
        setSelectedReservation(reservation);
        setShowEditModal(true);
    };
    
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Les mois commencent à 0
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };
   
    
    const handleSave = async (updatedReservation) => {


        try {
            let prestation = updatedReservation.prestation;
            if (parseInt(updatedReservation.nbrPersonne) > 9 || parseInt(updatedReservation.nbrPersonne) > 4 && updatedReservation.anniv=='oui') {
                prestation = prestation * updatedReservation.nbrPersonne;
            } else {
                prestation = 0;
            }
            // Ajout des données dans Firestore
            const reservationData = {
                ...updatedReservation,
                prestation,
                 date: formatDate(updatedReservation.date), 
            };

            const reservationDoc = doc(db, 'reservation', reservationData.id);
            await updateDoc(reservationDoc, reservationData);
            setReservations((prevReservations) =>
                prevReservations.map((r) =>
                    r.id === reservationData.id ? reservationData : r
                )
            );
            setShowEditModal(false); // Ferme le modal après la sauvegarde
        } catch (error) {
            console.error('Erreur lors de la mise à jour de la réservation :', error);
        }
    };
    

    const handleAdd = (newReservation) => {
        setReservations(prevReservations => [...prevReservations, newReservation]);
    };

    const handleDelete = async () => {
        try {
            if (reservationToDelete) {
                await deleteDoc(doc(db, 'reservation', reservationToDelete.id));
                setReservations(prevReservations => prevReservations.filter(p => p.id !== reservationToDelete.id));
                setShowConfirmModal(false);
                setReservationToDelete(null);
            }
        } catch (error) {
            console.error("Erreur lors de la suppression : ", error);
        }
    };

    const showConfirmationModal = (reservation) => {
        setReservationToDelete(reservation);
        setShowConfirmModal(true);
    };

    const hideConfirmationModal = () => {
        setShowConfirmModal(false);
        setReservationToDelete(null);
    };

    const handleStatusChange = (reservationId, newStatus) => {
        setEditedStatuses((prevStatuses) => ({
            ...prevStatuses,
            [reservationId]: newStatus,
        }));
    };

    const handleSaveStatus = async (reservationId) => {
        const newStatus = editedStatuses[reservationId];
        if (!newStatus) return;

        try {
            const reservationDoc = doc(db, 'reservation', reservationId);
            await updateDoc(reservationDoc, { statut: newStatus });

            setReservations((prevReservations) =>
                prevReservations.map((reservation) =>
                    reservation.id === reservationId
                        ? { ...reservation, statut: newStatus }
                        : reservation
                )
            );

            // Remove saved status from the editedStatuses state
            setEditedStatuses((prevStatuses) => {
                const updatedStatuses = { ...prevStatuses };
                delete updatedStatuses[reservationId];
                return updatedStatuses;
            });
        } catch (error) {
            console.error("Erreur lors de la mise à jour du statut : ", error);
        }
    };


    const statusColors = {
        soumis: 'badge-secondary',
        'en cours': 'badge-primary',
        confirmé: 'badge-success',
        terminé: 'badge-info',
        annulé: 'badge-danger',
    };

    return (
        <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
                <div className="container-fluid">
                    {user && user.role === 'L1QUmxerXDdx3DbWgY5H' && (
                        <button className="btn btn-red2 ml-auto" onClick={() => setShowAddModal(true)}>
                            <FontAwesomeIcon icon={faPlus} /> Ajouter une reservation
                        </button>
                    )}
                    <p className="mb-4"></p>
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex justify-content-between align-items-center">
                            <h6 className="m-0 font-weight-bold title-2 mr-2">Reservations</h6>
                            <input
                                type="text"
                                className="form-control w-25"
                                placeholder="Filtrer par date"
                                value={nameFilter}
                                onChange={(e) => setNameFilter(e.target.value)}
                            />
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered" id="dataTable" width="100%">
                                    <thead>
                                        <tr>
                                            <th>Date de reservation</th>
                                            <th>Heure de reservation</th>
                                            <th>Nombre de personnes</th>
                                            <th>Anniversaire oui/nom</th>
                                            <th>Prestation</th>
                                            <th>Statut</th>
                                            {user && user.role === 'L1QUmxerXDdx3DbWgY5H' && (
                                                <th>Action</th>
                                            )}
                                            <th>Nom</th>
                                            <th>Téléphone</th>
                                            <th>Type de gâteau</th>
                                            <th>Personnaliser le gâteau</th>
                                            <th>Age de la personne</th>
                                            <th>Email</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentReservations.map((reservation) => (
                                            <tr key={reservation.id}>
                                                <td>{reservation.date}</td>
                                                <td>{reservation.heure}</td>
                                                <td>{reservation.nbrPersonne}</td>
                                                <td>{reservation.anniv}</td>
                                                <td>{reservation.prestation}</td>
                                                <td><select
                                                        className={`form-control width-100 ${statusColors[reservation.statut]}`}
                                                     
                                                        value={reservation.statut}
                                                        onChange={(e) =>
                                                            handleStatusChange(reservation.id, e.target.value)
                                                        }
                                                    >
                                                        <option value="soumis">Soumis</option>
                                                        <option value="en cours">En cours</option>
                                                        <option value="confirmé">Confirmé</option>
                                                        <option value="terminé">Terminé</option>
                                                        <option value="annulé">Annulé</option>
                                                    </select></td>
                                                <td className='d-flex'>
                                                    {user && user.role === 'L1QUmxerXDdx3DbWgY5H' && (
                                                        <>
                                                            {editedStatuses[reservation.id] && (
                                                                <button
                                                                    className="btn btn-success btn-circle btn-sm"
                                                                    onClick={() => handleSaveStatus(reservation.id)}
                                                                >
                                                                    <FontAwesomeIcon icon={faSave} /> 
                                                                </button>
                                                            )}
                                                            <Link className="btn btn-primary btn-circle btn-sm ml-2" to="#" onClick={() => handleShowEdit(reservation)}>
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </Link>
                                                            <Link
                                                                className="btn btn-danger btn-circle btn-sm ml-2" to="#"
                                                                onClick={() => showConfirmationModal(reservation)}
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </Link>
                                                        </>
                                                    )}
                                                </td>
                                                <td>{reservation.nom}</td>
                                                <td>{reservation.tele}</td>
                                                <td>{reservation.typeGateau}</td>
                                                <td>{reservation.texteGateau}</td>
                                                <td>{reservation.ageP}</td>
                                                <td>{reservation.email}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <ReactPaginate
                                    previousLabel={'Précédent'}
                                    nextLabel={'Suivant'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination justify-content-end'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AddReservationModal
                show={showAddModal}
                handleClose={() => setShowAddModal(false)}
                handleSave={handleAdd}
            />
            <EditReservationModal
                show={showEditModal}
                handleClose={() => setShowEditModal(false)}
                reservation={selectedReservation}
                handleSave={handleSave}
            />


            {/* Confirmation Modal */}
            <Modal show={showConfirmModal} onHide={hideConfirmationModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir supprimer cette réservation ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={hideConfirmationModal}>
                        Annuler
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Supprimer
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Reservations;
